import PropTypes from 'prop-types';
import React from 'react';
import { resultsConfigSelector } from 'ctm-selectors';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getBrand } from '../../../../ctm-app/client/store/selectors';
import { FrequencyToggle } from '../frequency_toggle/frequency_toggle';
import styles from './price.css';

const Price = ({ price, frequency, showFrequency, showFrequencyToggle, origin }) => {
    const [dollar, cents] = parseFloat(price).toFixed(2).toString().split('.');
    const frequencyLabel = frequency === 'annual' ? 'annually' : 'monthly';
    const choosi = useSelector(getBrand) === 'choo';

    const displayMode = useSelector((state) => resultsConfigSelector(state).get('displayMode'));
    const frequencyComponent = getFrequency({ frequencyLabel, showFrequency, showFrequencyToggle, frequency });

    const isRowDisplayMode = displayMode === 'row';
    const isProductOrigin = origin === 'product';

    return (
        <div data-test-id={'price-container'}>
            <div className={classNames(choosi ? styles.price_choo : styles.price)}>
                $
                <span data-id={'quote-price-dollar'} data-test-id={'quote-price-dollar'} className={classNames(choosi ? styles.dollar_choo : styles.dollar)}>{dollar}</span>
                <div className={styles.meta}>
                    <span data-id={'quote-price-cents'} data-test-id={'quote-price-cents'}>{cents}</span>
                    {(isRowDisplayMode || isProductOrigin) && frequencyComponent}
                </div>
            </div>
            {!isRowDisplayMode && !isProductOrigin && (
                <div data-testid={'paymentFrequency'} data-test-id={'payment-frequency'} className={styles.payment_frequency_container}>{frequencyComponent}</div>
            )}
        </div>
    );
};

const getFrequency = (frequencyProps) => {
    const { frequencyLabel, showFrequency, showFrequencyToggle, frequency } = frequencyProps;
    if (showFrequency && showFrequencyToggle) {
        return <FrequencyToggle frequency={frequency} label={frequencyLabel} />;
    } if (showFrequency) {
        return <span className={styles.frequency}>{frequencyLabel}</span>;
    }
    return null;
};

Price.defaultProps = {
    showFrequency: true,
    price: 0.00,
    frequency: 'annual',
    showFrequencyToggle: false
};

Price.propTypes = {
    price: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    frequency: PropTypes.string,
    showFrequency: PropTypes.bool,
    showFrequencyToggle: PropTypes.bool,
    origin: PropTypes.string
};

export { Price };
